// Regra de status do cálculo de um cenário de metas: as abas Período e
// Manutenção precisam falar a mesma coisa (calculando, calculado, publicado ou
// nenhum dos três), então a regra fica centralizada aqui em vez de duplicada
// nas duas.

import type { StatusCenario } from "@/api/metas.service";

export interface StatusCalculo {
  /** Sem cálculo não há metas para revisar. */
  calculado: boolean;
  /** Publicado é somente leitura. */
  publicado: boolean;
  /** O motor ainda está rodando: o cenário não aceita nenhuma ação até terminar. */
  calculando: boolean;
  /** A publicação ainda está rodando: o cenário não aceita nenhuma ação até terminar. */
  publicando: boolean;
}

/** Traduz o status bruto do back-end (RASCUNHO/ENVIADO/CALCULANDO/CALCULADO/PROMOVENDO/PROMOVIDO) para a leitura que as duas abas usam. */
export function statusCalculoDe(status: StatusCenario): StatusCalculo {
  return {
    // CALCULANDO ainda não produziu resultado nenhum — só CALCULADO e
    // PROMOVIDO têm metas para a aba de Manutenção revisar.
    calculado: status === "CALCULADO" || status === "PROMOVENDO" || status === "PROMOVIDO",
    publicado: status === "PROMOVIDO",
    calculando: status === "CALCULANDO",
    publicando: status === "PROMOVENDO",
  };
}

/** `ajustavelPublicado`: na Manutenção o cenário publicado ainda aceita ajustes e republicação. */
export function situacaoDe(status: StatusCalculo, ajustavelPublicado = false) {
  if (status.calculando) return "Calculando...";
  if (status.publicando) return "Publicando...";
  if (!status.calculado) return "Não calculado";
  return status.publicado ? (ajustavelPublicado ? "Publicado · republicação liberada" : "Publicado · somente leitura") : "Calculado · edição liberada";
}

export function corSituacao(status: StatusCalculo): "default" | "success" | "primary" | "info" {
  if (status.calculando || status.publicando) return "info";
  if (!status.calculado) return "default";
  return status.publicado ? "success" : "primary";
}
